import clsx from 'clsx'
import React, { FC } from 'react'
import styled from 'styled-components'

import { Button, ButtonProps } from '@Components/Button'
import { Progress, ProgressProps } from '@Components/Progress'

interface ButtonWithProgressProps extends ButtonProps {
  loading: boolean
}

const progressColor = (
  buttonColor: ButtonProps['color'],
  buttonVariant: ButtonProps['variant'],
): ProgressProps['color'] => {
  if (buttonVariant === 'outlined') {
    if (buttonColor === 'primary') {
      return 'primary'
    }
    return 'grey'
  }

  if (buttonColor === 'white') {
    return 'grey'
  }

  return 'white'
}

const progressSize = (
  buttonSize: ButtonProps['size'],
): ProgressProps['size'] => {
  if (buttonSize === 'small') {
    return 'x-small'
  }

  return 'small'
}

const StyledButtonWithProgress = styled.div`
  margin-bottom: 10px;
  & > button {
    margin-bottom: 0;
  }
  &.loading {
    position: relative;
    & > button {
      span {
        opacity: 0;
      }
    }
    & > div {
      position: absolute;
    }
  }
`

export const ButtonWithProgress: FC<ButtonWithProgressProps> = (
  {
    children,
    className,
    color = 'primary',
    loading = false,
    size = 'medium',
    variant = 'full',
    ...props
  }: ButtonWithProgressProps,
) => (
  <StyledButtonWithProgress className={clsx({ loading }, className)}>
    <Button
      className={className}
      color={color}
      size={size}
      variant={variant}
      {...props}
    >
      {children}
    </Button>
    {loading && (
      <Progress
        center
        color={progressColor(color, variant)}
        size={progressSize(size)}
      />
    )}
  </StyledButtonWithProgress>
)
